import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import {
  ApprovalDto,
  ApprovalDetailDto,
  DetectedFileInfo,
  DownloadHistoryInfo,
  FileDetailsInfo,
  FileInfoDto,
} from './approvalApi';
import { UseYN } from '../infra';
import { toBoolean } from 'src/shared/utils/infra';
const FXM_API_URL = config.servers.fxm.url;
export interface ExchangeOfflineApprovalDto extends ApprovalDto {
  approvalNo: string;
  submission: string;
  rightView: UseYN; //권한(열람) Y/N
  rightPrint: UseYN; //권한(인쇄) Y/N
  viewStartTs: number; //패키징 시 열람 가능 시작 시간
  viewEndTs: number; //패키징 시 열람 가능 종료 시간
}

export interface ExchangeOfflineApprovalDetailDto extends ApprovalDetailDto {
  submission: string;
  rightView: UseYN; //권한(열람) Y/N
  rightPrint: UseYN; //권한(인쇄) Y/N
  viewStartTs: number; //패키징 시 열람 가능 시작 시간
  viewEndTs: number; //패키징 시 열람 가능 종료 시간
  fileDetails: FileDetailsInfo[];
  downloadHistory: DownloadHistoryInfo[];
  detectedFiles?: DetectedFileInfo[];
}
export type ExchangeOfflineApprovalReqDto = ExchangeOfflineApprovalDto;
export interface ApplyGenKeyDto {
  approvalNo: string;
}
export interface ExchangeOfflineApprovalDetailEntity
  extends Omit<ExchangeOfflineApprovalDetailDto, 'code' | 'rightView' | 'rightPrint'> {
  rightView: boolean; //권한(열람) Y/N
  rightPrint: boolean; //권한(인쇄) Y/N
}
export const toExchangeOfflineApprovalDetailDtoToEntity = (
  dto: ExchangeOfflineApprovalDetailDto
): ExchangeOfflineApprovalDetailEntity => {
  return {
    ...dto,
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
    rightView: toBoolean(dto.rightView),
    rightPrint: toBoolean(dto.rightPrint),
  };
};
interface ExchangeOfflineApprovalApi {
  find(approvalNo: string): Promise<ExchangeOfflineApprovalDetailEntity>; // 사용자 > 내 신청함 > 결재 완료 이외 부분에서 사용하는 API
  find2(approvalNo: string): Promise<ExchangeOfflineApprovalDetailEntity>; // 사용자 > 내 신청함 > 결재완료에서 사용 하는 API
  getGenKey(): Promise<ApplyGenKeyDto>;
  fileUpload(
    approvalNo: string,
    code: string,
    files: File[],
    progressConfig: {
      onUploadProgress: (progressEvent: any) => void;
    }
  ): Promise<FileInfoDto[]>;
  deleteUploadFile(approvalNo: string, fileUuid: string): Promise<FileInfoDto>;
  deleteUploadFiles(approvalNo: string, fileUuids: string[]): Promise<FileInfoDto[]>;
  apply(reqDto: ExchangeOfflineApprovalReqDto): Promise<ExchangeOfflineApprovalDetailDto>;
  cancel(approvalNo: string): Promise<boolean>;
}
class ExchangeOfflineApprovalServerApi implements ExchangeOfflineApprovalApi {
  async find(approvalNo: string): Promise<ExchangeOfflineApprovalDetailEntity> {
    const resp = await axios.get<ExchangeOfflineApprovalDetailDto>(
      `${FXM_API_URL}/api/exchangeoffline/find/${approvalNo}`
    );
    return toExchangeOfflineApprovalDetailDtoToEntity(resp.data);
  }
  async find2(approvalNo: string): Promise<ExchangeOfflineApprovalDetailEntity> {
    const resp = await axios.get<ExchangeOfflineApprovalDetailDto>(
      `${FXM_API_URL}/api/exchangeoffline/find2/${approvalNo}`
    );
    return toExchangeOfflineApprovalDetailDtoToEntity(resp.data);
  }
  async getGenKey(): Promise<ApplyGenKeyDto> {
    const resp = await axios.get<ApplyGenKeyDto>(`${FXM_API_URL}/api/genkey`);
    return resp.data;
  }
  async fileUpload(
    approvalNo: string,
    code: string,
    files: File[],
    progressConfig: {
      onUploadProgress: (progressEvent: any) => void;
    }
  ): Promise<FileInfoDto[]> {
    const form = new FormData();
    form.append('approvalType', 'EXCHANGEOFFLINE');
    form.append('approvalNo', approvalNo);
    form.append('code', code);
    files.map((file) => form.append('files', file));

    const resp = await axios.post<FileInfoDto[]>(
      `${FXM_API_URL}/api/exchangeoffline/upload`,
      form,
      progressConfig
    );

    return resp.data;
  }

  async deleteUploadFile(approvalNo: string, fileUuid: string): Promise<FileInfoDto> {
    const resp = await axios.get<FileInfoDto>(
      `${FXM_API_URL}/api/exchangeoffline/delete/one/${approvalNo}/${fileUuid}`
    );
    return resp.data;
  }
  async deleteUploadFiles(approvalNo: string, fileUuids: string[]): Promise<FileInfoDto[]> {
    const resp = await axios.post<FileInfoDto[]>(
      `${FXM_API_URL}/api/exchangeoffline/delete/many/${approvalNo}`,
      fileUuids
    );
    return resp.data;
  }

  async apply(reqDto: ExchangeOfflineApprovalReqDto): Promise<ExchangeOfflineApprovalDetailDto> {
    const resp = await axios.post<ExchangeOfflineApprovalDetailDto>(
      `${FXM_API_URL}/api/exchangeoffline/apply`,
      reqDto
    );
    return resp.data;
  }

  async cancel(approvalNo: string): Promise<boolean> {
    await axios.get<ExchangeOfflineApprovalDetailDto>(
      `${FXM_API_URL}/api/exchangeoffline/cancel/${approvalNo}`
    );
    return true;
  }
}
const exchangeOfflineApprovalApi = new ExchangeOfflineApprovalServerApi();
export default exchangeOfflineApprovalApi;
